import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { InternalReferentialsBaseService } from "src/app/core/base/internal-referentials-base.service";
import { environment } from "src/environments/environment";
import { Currency } from "./currency.model";

export const CURRENCY_BASE_URL = `${environment.baseUrl}/engine/currencies`;

@Injectable({
  providedIn: "root",
})
export class CurrencyService extends InternalReferentialsBaseService<
  Currency,
  number
> {
  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient, CURRENCY_BASE_URL);
  }
}
